import React from "react"
import PropTypes from "prop-types"

import FSLogo from "../../images/fansided-logo.svg"
import SocialShare from "../SocialShare/SocialShare"
import styles from "./Header.module.scss"

const Header = ({ siteTitle, border, shareText, shareUrl }) => (
    <header
        className={`${styles.headerContainer} ${
            border ? `${styles.border}` : ""
        }`}
    >
        <a
            href="https://hiddenremote.com/"
            rel="noopener noreferrer"
            target="_blank"
            className={styles.navFSLogo}
        >
            <img
                src={FSLogo}
                className={styles.fansidedLogo}
                alt="FanSided Logo"
            />
        </a>

        <h2 className={styles.quizTitle}>{siteTitle}</h2>

        <SocialShare
            className={styles.socialShare}
            shareUrl={shareUrl}
            shareText={shareText}
        />
    </header>
)

Header.defaultProps = {
    border: false,
}

Header.propTypes = {
    shareText: PropTypes.string.isRequired,
    shareUrl: PropTypes.string.isRequired,
    siteTitle: PropTypes.string.isRequired,
    border: PropTypes.bool,
}

export default Header
